import { render } from "./ExpensesForm.vue?vue&type=template&id=67293fb2&scoped=true"
import script from "./ExpensesForm.vue?vue&type=script&lang=js"
export * from "./ExpensesForm.vue?vue&type=script&lang=js"

import "./ExpensesForm.vue?vue&type=style&index=0&id=67293fb2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67293fb2"]])

export default __exports__